import(/* webpackMode: "eager", webpackExports: ["ProblemWorkspaceClient"] */ "/vercel/path0/features/judge/components/ProblemWorkspaceClient.tsx");
